export enum LocalStorage {
  ORGANIZATION_ORDERS = "organization_orders",
  USER = "user",
  DINING_MODE = "dining_mode",
  BRANCH_ID = "branchId",
  // Enviroments
  ENVIRONMENT = "environment",
  //Chrome
  CHROME_FREEZE_CONFIGURED = "chrome-freeze-configured",
}


